import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
const Social = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="hidden lg:flex items-center gap-x-3 min-h-full">
      <a
        href={`tel:${
          i18n.language === "ar" ? "+966598670797" : "+966598670797"
        }`}
        className="flex items-center  gap-x-2 text-black"
      >
        {/* <span className="bg-primary text-white h-6 w-6 text-xl rounded-full p-1 flex items-center justify-center">
          <WhatsappLogo />
        </span> */}
        <p dir="ltr" className="text-lg">
          {i18n.language === "ar" ? "+966 5986 70797" : "+966 5986 70797"}
        </p>
      </a>
    </div>
  );
};

export default Social;
